export const TARGET_DOMAIN = 'clevertap-prod.com'
export const TARGET_PROTOCOL = 'https:'
export const DEFAULT_REGION = 'eu1'
